import { HttpClient } from '@angular/common/http'
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core'
import { CMSTabParagraphContainer, CmsService, OccConfig, Product, WindowRef } from '@spartacus/core'
import {
  BREAKPOINT,
  BreakpointService,
  CmsComponentData,
  CurrentProductService,
  ICON_TYPE,
  TabParagraphContainerComponent
} from '@spartacus/storefront'
import { FileSaverService } from 'ngx-filesaver'
import { Observable, Subject, Subscription } from 'rxjs'
import { finalize, tap } from 'rxjs/operators'
import { ErrorTypes } from '../../../models/enum/error.enum'
import { ErrorMessage } from '../../../models/error.model'
import { ICustomProduct } from '../../../models/interface/product.interface'
import { FileService } from '../../../services/file.service'
import { ProductDetailsService } from '../../../services/product.service'
import { UserPermissionService } from '../../../services/user-permission/user-permission.service'

export interface CustomProduct extends Product {
  documents?: {
    description?: string
    documentDataType?: string
    documentId?: string
    mimeType?: string
    url?: string
  }
}

@Component({
    selector: 'app-custom-tab-paragraph-container',
    templateUrl: './custom-tab-paragraph-container.component.html',
    styleUrls: ['./custom-tab-paragraph-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CustomTabParagraphContainerComponent extends TabParagraphContainerComponent implements OnInit, OnDestroy {
  public isMobileView = false
  active = 1
  private componentSubscription = new Subscription()
  iconType = ICON_TYPE
  product$: Observable<CustomProduct>
  // activeTabNum;
  // vimal already declare in base class
  private readonly onDestroy = new Subject<void>()
  public emptyProduct = false
  public productExists = false
  public errorMessage: ErrorMessage = new ErrorMessage()
  public countdownSeconds = 5
  public product: Product
  public spinner = false
  public activeLink: number

  constructor(
    componentData: CmsComponentData<CMSTabParagraphContainer>,
    cmsService: CmsService,
    winRef: WindowRef,
    private cd: ChangeDetectorRef,
    // TODO:Spartacus - Property 'breakpointService' was removed from Class 'TabParagraphContainerComponent'.
    public breakpointService: BreakpointService,
    private productDetailsService: ProductDetailsService,
    protected currentProductService: CurrentProductService,
    private changeDetectorRef: ChangeDetectorRef,
    private httpClient: HttpClient,
    private fileSaverService: FileSaverService,
    private occConfig: OccConfig,
    private fileService: FileService,
    public userPermissionService: UserPermissionService
  ) {
    // super(componentData, cmsService, winRef);
    super(componentData, cmsService, winRef)
  }

  ngOnInit(): void {
    // super.ngOnInit();
    // vimal
    this.componentSubscription.add(this.subscribeToBreakpointChanges())
    this.componentSubscription.add(this.subscribeToReviewsRedirect())

    this.makeErrorMessage()
    this.product$ = this.productDetailsService.getProductDetail$().pipe(
      tap((product) => {
        if (product) {
          this.product = product
          this.productExists = true
          this.emptyProduct = false
          this.changeDetectorRef.detectChanges()
        } else {
          this.productExists = false
          this.emptyProduct = true
          this.changeDetectorRef.detectChanges()
        }
      })
    )
  }

  makeErrorMessage(): void {
    this.errorMessage.title = 'This product is not currently available'
    this.errorMessage.message = 'Please contact us for more information'
    this.errorMessage.buttonMessage = 'Return to Dashboard'
    this.errorMessage.type = ErrorTypes.productNotFound
    this.errorMessage.url = './'
  }

  // TODO:Spartacus - Method 'ngOnDestroy' was removed from Class 'TabParagraphContainerComponent'.
  ngOnDestroy(): void {
    // TODO:Spartacus - Method 'ngOnDestroy' was removed from Class 'TabParagraphContainerComponent'.
    //super.ngOnDestroy();
    this.componentSubscription.unsubscribe()
    this.onDestroy.next()
    this.onDestroy.complete()
  }

  select(tabNum: number): void {
    if (this.isMobileView) {
      this.activeTabNum = this.activeTabNum === tabNum ? null : tabNum
    } else {
      this.activeTabNum = tabNum
    }
  }

  clickOnTab(index: number): void {
    const tabHeader: HTMLElement = document.getElementById(this.generateTabHeaderId(index))

    setTimeout(() => {
      tabHeader.scrollIntoView({
        block: 'start',
        behavior: 'smooth'
      })
    }, 0)
  }

  generateTabHeaderId(index: number): string {
    return `tab-header-${index}`
  }

  private subscribeToReviewsRedirect(): Subscription {
    return this.productDetailsService.redirectToReviews.subscribe(() => {
      // Reviews tab has index 2
      this.select(2)
      this.clickOnTab(2)
      this.cd.detectChanges()
    })
  }

  private subscribeToBreakpointChanges(): Subscription {
    // TODO:Spartacus - Property 'breakpointService' was removed from Class 'TabParagraphContainerComponent'.
    return this.breakpointService.breakpoint$.subscribe((breakpoint: BREAKPOINT) => {
      if (breakpoint === BREAKPOINT.xs) {
        this.isMobileView = true
        this.activeTabNum = null
      } else {
        this.isMobileView = false
      }
    })
  }

  public onDocumentClick(product: ICustomProduct, document): void {
    this.spinner = true
    const fileType = this.fileService.mimeConvertor(document.mimeType)
    const fileName = document.description + fileType
    const getDocumentURL: string = this.GenerateDownloadUrl(
      product.code,
      document.documentId,
      document.mimeType,
      document.documentDataType
    )
    this.httpClient
      .get(`${getDocumentURL}`, {
        observe: 'response',
        responseType: 'blob'
      })
      .pipe(
        finalize(() => {
          this.spinner = false
          this.changeDetectorRef.detectChanges()
        })
      )
      .subscribe((res) => {
        this.fileSaverService.save(res.body, fileName)
      })
  }

  public GenerateDownloadUrl(
    productId: string,
    documentId: string,
    mimeType: string,
    documentDataType: string
  ): string {
    const occBaseUrl: string = this.occConfig.backend.occ.baseUrl
    const prefix: string = this.occConfig.backend.occ.prefix
    const context: string = this.occConfig.context.baseSite[0]
    const productsParameter = '/products/'
    const downloadDocumentParameter = '/downloadDocument/'
    const dataType: string = this.fileService.getDocumentDataType(documentDataType)
    const documentDataTypeParameter = '?documentDataType=' + dataType
    const type = `&mimeType=${mimeType}`
    // tslint:disable-next-line: max-line-length
    const getDocumentURL: string =
      occBaseUrl +
      prefix +
      context +
      productsParameter +
      productId +
      downloadDocumentParameter +
      documentId +
      documentDataTypeParameter +
      type
    return getDocumentURL
  }

  public downloadNewLineForm(product: ICustomProduct): void {
    if (!product) {
      return
    }
    this.productDetailsService.downloadNewLineForm(product)
  }

  public showTab(component: any): boolean {
    const uid = component?.uid
    if (!uid) {
      return false
    }

    switch (uid) {
      case 'ProductDocumentsTabComponent':
        return this.userPermissionService.downloadProductInfo

      default:
        return true
    }
  }
}
